import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom'
import { AuthProvider } from './context/auth';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'antd/dist/reset.css'
import { SearchProvider } from './context/search';
import { CartProvider } from './context/cart';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <AuthProvider>
    <SearchProvider>
      <CartProvider>
        <Router>

          <App />

        </Router>
      </CartProvider>
    </SearchProvider>
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
